import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetDnbarcodeDtlList as _GetDnbarcodeDtlList, CreateOutBoxBarcodeData, GetDnbarcodePartBoxDtlList as _GetDnbarcodePartBoxDtlList, GetPartBarcodeDetailPageList, SaveData } from '@/api/DnbarcodeHandmade';
import { mapActions, mapGetters } from 'vuex';
import XEUtils from 'xe-utils';
import util from '@/libs/util';
import changeMaterialDialog from './changeMaterialDialog';
export default {
  components: {
    changeMaterialDialog: changeMaterialDialog
  },
  mounted: function mounted() {},
  data: function data() {
    var SPQValid = function SPQValid(cellValue) {
      var SPQ = Number(cellValue.row.SPQ);

      if (SPQ === 0) {
        return new Error('裝箱数量不能为0或少于0');
      }
    };

    var TOTAL_QTYValid = function TOTAL_QTYValid(cellValue) {
      var TOTAL_QTY = Number(cellValue.row.TOTAL_QTY);

      if (TOTAL_QTY === 0) {
        return new Error('打印数量不能为0或少于0');
      }
    };

    return {
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      pageInfo: {
        TotalCount: null,
        size: null,
        current: null
      },
      loading: false,
      editConfig: {
        trigger: null,
        mode: null,
        showStatus: true
      },
      tableHeaderInfo: {},
      canEdit: false,
      vxeRules: {
        SPQ: [{
          required: true,
          message: '装箱数量必须填写'
        }, {
          validator: SPQValid
        }],
        TOTAL_QTY: [{
          required: true,
          message: '打印数量必须填写'
        }, {
          validator: TOTAL_QTYValid
        }]
      },
      isShowChangeMaterialDialog: false,
      isShowPageBar: true,
      isShowOptionColumn: false,
      formData: {
        ID: null,
        DELIVERY_NO: null,
        // 送货单号
        DESCRIPTION: null,
        // 备注
        CREATETIME: null,
        // 创建日期
        VENDOR_CODE: null,
        // 供应商代码
        VENDOR_NAME: null // 供应商名称

      },
      userInfo: JSON.parse(util.cookies.get('userInfo')),
      submitID: null,
      materVENDOR_CODE: null,
      selectedTableData: [],
      MST_ID: null,
      currentPane: 'material',
      barcodeData: [],
      isAdd: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DnbarcodeHandmadeOutBox', ['setOrderStatu'])), {}, {
    vxeFormatDate: function vxeFormatDate(_ref) {
      var cellValue = _ref.cellValue;
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd');
    },
    // 点击明细删除
    hanldeDelete: function hanldeDelete(row) {
      var _this = this;

      // console.log(row);
      this.$confirm('确认删除此明细？', this.$t('Manager.prompt'), {
        confirmButtonText: this.$t('Manager.confirm'),
        cancelButtonText: this.$t('Manager.cancel'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$refs.vxeTable.remove(row);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    resetCurrentPane: function resetCurrentPane() {
      this.currentPane = 'material';
    },
    valiHasPartBarcode: function valiHasPartBarcode() {
      var _this2 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve) {
          var params, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  params = {
                    Page: _this2.pageInfo.PageIndex,
                    Limit: _this2.pageInfo.PageSize,
                    MST_ID: _this2.tableHeaderInfo.ID ? _this2.tableHeaderInfo.ID : _this2.MST_ID,
                    ORGANIZE_ID: util.cookies.get('ORG_ID')
                  };
                  _context2.next = 3;
                  return _GetDnbarcodePartBoxDtlList(params);

                case 3:
                  res = _context2.sent;

                  if (res.code === 0) {
                    if (res.data.length > 0) {
                      resolve(true);
                    } else {
                      resolve(false);
                    }
                  } else {
                    _this2.$message.warning('检查条码列表失败');
                  }

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    // 点击tab
    handleTab: function handleTab() {
      if (this.currentPane === 'barCode') {
        // console.log(this.tableHeaderInfo);
        this.barcodeData = [];
        this.GetDnbarcodePartBoxDtlList();
      }
    },
    // 获取条码列表
    GetDnbarcodePartBoxDtlList: function GetDnbarcodePartBoxDtlList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  MST_ID: _this3.tableHeaderInfo.ID ? _this3.tableHeaderInfo.ID : _this3.MST_ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _this3.loading = true;
                _context3.next = 4;
                return _GetDnbarcodePartBoxDtlList(params);

              case 4:
                res = _context3.sent;
                _this3.loading = false;
                console.log(res);

                if (res.code === 0) {
                  _this3.barcodeData = res.data;
                } else {
                  _this3.$message.warning('获取条码列表失败');
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 设置数据
    setListData: function setListData(data) {
      console.log('设置数据', data);
      this.tableHeaderInfo = data;
      this.MST_ID = data.ID;
      this.GetDnbarcodeDtlList();
    },
    // 点击保存
    saveData: function saveData(TabelHeaderData) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var $table, errMap, InsertRecords, RemoveRecords, UpdateRecords, mstModel, params, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('TabelHeaderData', TabelHeaderData);
                $table = _this4.$refs.vxeTable;

                if (!$table) {
                  _context4.next = 30;
                  break;
                }

                if (!($table.getTableData().visibleData.length === 0)) {
                  _context4.next = 6;
                  break;
                }

                _this4.$message.warning('需添加物料明细');

                return _context4.abrupt("return");

              case 6:
                _context4.next = 8;
                return $table.validate().catch(function (errMap) {
                  return errMap;
                });

              case 8:
                errMap = _context4.sent;

                if (!errMap) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return");

              case 11:
                InsertRecords = _this4.$refs.vxeTable.getRecordset().insertRecords.map(function (v) {
                  var obj = {
                    PART_NO: v.PART_NO,
                    PART_NAME: v.PART_NAME,
                    PART_DESCR: v.PART_DESCR,
                    LOT_NO: v.LOT_NO,
                    SPQ: v.SPQ,
                    TOTAL_QTY: v.TOTAL_QTY,
                    PO_UNIT: v.PO_UNIT,
                    BASE_UNIT: v.BASE_UNIT,
                    UNIT_EXRATE: v.UNIT_EXRATE,
                    DESCRIPTION: v.DESCRIPTION,
                    DATE_CODE: v.DATE_CODE // PACKING_QTY:Number(v.PACKING_QTY)

                  };
                  return obj;
                });
                RemoveRecords = _this4.$refs.vxeTable.getRecordset().removeRecords;
                UpdateRecords = _this4.$refs.vxeTable.getRecordset().updateRecords; // console.log(this.$refs.vxeTable.getRecordset());
                // console.log('RemoveRecords',RemoveRecords);
                // console.log('UpdateRecords',UpdateRecords);
                // if(InsertRecords.length === 0 && RemoveRecords.length === 0 && UpdateRecords.length === 0){
                //     InsertRecords = this.$refs.vxeTable.getTableData().tableData.map(v=>{
                //         let obj = {
                //             PART_NO:v.PART_NO,
                //             PART_NAME:v.PART_NAME,
                //             PART_DESCR:v.PART_DESCR,
                //             LOT_NO:v.LOT_NO,
                //             SPQ:v.SPQ,
                //             TOTAL_QTY:v.TOTAL_QTY,
                //             PO_UNIT:v.PO_UNIT,
                //             BASE_UNIT:v.BASE_UNIT,
                //             UNIT_EXRATE:v.UNIT_EXRATE,
                //             DESCRIPTION:v.DESCRIPTION
                //         }
                //         return obj
                //     })
                // }

                if (InsertRecords.length === 0 && RemoveRecords.length === 0 && UpdateRecords.length === 0) {
                  UpdateRecords = $table.getTableData().visibleData;
                }

                mstModel = {};
                mstModel.ID = TabelHeaderData.ID ? TabelHeaderData.ID : 0;
                mstModel.CREATORID = JSON.parse(util.cookies.get('userInfo')).USER_NAME;
                mstModel.ORGANIZE_ID = util.cookies.get('ORG_ID');
                mstModel.VENDOR_CODE = TabelHeaderData.VENDOR_CODE;
                mstModel.VENDOR_NAME = TabelHeaderData.VENDOR_NAME;
                mstModel.DESCRIPTION = TabelHeaderData.DESCRIPTION;
                mstModel.DELIVERY_NO = TabelHeaderData.DELIVERY_NO;
                params = {
                  mstModel: mstModel,
                  InsertRecords: InsertRecords,
                  RemoveRecords: RemoveRecords,
                  UpdateRecords: UpdateRecords,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                console.log('params', params);
                _context4.next = 27;
                return SaveData(params);

              case 27:
                res = _context4.sent;
                console.log(res);

                if (res.code === 0) {
                  _this4.$message.success('保存成功'); // this.setOrderStatu('listShow')


                  _this4.MST_ID = res.data;
                  _this4.tableHeaderInfo.ID = res.data;

                  _this4.$emit('saveSuccess', _this4.MST_ID);
                }

              case 30:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 单行打印
    handleRowPrint: function handleRowPrint(row) {
      console.log('点击单行', row);
      this.$emit('handleRowPrint', row);
    },
    // 设置ID
    setID: function setID(id) {
      this.submitID = id;
    },
    // 打开选择送货单dialog
    ShowChangeMaterialDialog: function ShowChangeMaterialDialog(VENDOR_CODE, selectedTableData) {
      var _this5 = this;

      this.materVENDOR_CODE = VENDOR_CODE;
      this.isShowChangeMaterialDialog = true;
      this.selectedTableData = selectedTableData;
      this.$nextTick(function () {
        _this5.$refs.changeMaterialDialog.GetMeterList();
      });
    },
    // 获取明细物料List
    GetDnbarcodeDtlList: function GetDnbarcodeDtlList() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.currentPane = 'material';
                params = {
                  MST_ID: _this6.MST_ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context5.next = 4;
                return _GetDnbarcodeDtlList(params);

              case 4:
                res = _context5.sent;
                console.log('明细物料List', res);

                if (res.code === 0) {
                  _this6.tabelData = res.data;
                }

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 生成标签
    handleCreateOutBoxBarcodeData: function handleCreateOutBoxBarcodeData(TabelHeaderData) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('TabelHeaderData', TabelHeaderData);
                params = {
                  ID: TabelHeaderData ? TabelHeaderData.ID : _this7.MST_ID,
                  CREATORID: _this7.userInfo.USER_NAME,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                }; // console.log('params',params);

                _this7.$openLoading();

                _context6.next = 5;
                return CreateOutBoxBarcodeData(params);

              case 5:
                res = _context6.sent;

                _this7.$closeLoading(); // console.log('res',res);


                if (res.code === 0) {
                  _this7.$message.success('生成外箱标签成功!');

                  _this7.GetDnbarcodePartBoxDtlList();
                } else {
                  _this7.$message.warning('已存在标签列表');
                } // if(res.code === 0){
                //     let res2 = await CreateInnerBoxCodeData(params)
                //     console.log('res2',res2);
                //     this.GetDnbarcodePartBoxDtlList(TabelHeaderData)
                // }else{
                //     this.$message.warning('已生成条码')
                //     return
                // }
                // console.log('res2',res2);


              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 获取当前时间
    getNowDate: function getNowDate(date) {
      var line = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + line + m + line + d;
    },
    // 明细dialog确定按钮回调
    cbDialogSubmit: function cbDialogSubmit(selectRecords) {
      var now = this.getNowDate(new Date());
      var now2 = this.getNowDate(new Date(), '-');
      var rowList = JSON.parse(JSON.stringify(selectRecords)).map(function (v) {
        v.LOT_NO = now;
        v.DATE_CODE = now2;
        return v;
      });
      this.$refs.vxeTable.insertAt(rowList, -1); // console.log('this.tabelData',this.tabelData);

      this.$emit('cbTabelData', rowList);
    },
    // 明细dialog关闭
    closeChangeMaterialDialog: function closeChangeMaterialDialog() {
      this.isShowChangeMaterialDialog = false;
    },
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.current = index;
      this.getOrderInfo();
    },
    // 切换页码
    handleSizeChange: function handleSizeChange(value) {
      // console.log(value);
      this.pageInfo.size = value;
      this.getOrderInfo();
    }
  }),
  watch: {
    $DnbarcodeHandmadeOutBoxState: {
      handler: function handler(nawValue) {
        if (nawValue === 'listShow') {
          this.tabelData = [];
          this.isShowOptionColumn = false;
          this.isAdd = false;
        } else if (nawValue === 'orderShow') {
          this.editConfig.trigger = null;
          this.editConfig.mode = null;
          this.canEdit = false;
          this.GetDnbarcodeDtlList();
          this.isShowOptionColumn = false;
          this.isAdd = false;
        } else if (nawValue === 'editOrder') {
          this.editConfig.trigger = 'click';
          this.editConfig.mode = 'row';
          this.canEdit = true;
          this.isShowOptionColumn = true;
          this.isAdd = false;
        } else if (nawValue === 'addOrder') {
          this.editConfig.trigger = 'click';
          this.editConfig.mode = 'row';
          this.canEdit = true;
          this.isShowOptionColumn = true;
          this.isAdd = true;
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DnbarcodeHandmadeOutBoxState', 'userinfo']))
};